import {Action} from 'redux';
import {
  WS_CONNECTED,
  WS_DISCONNECTED,
} from './constants';

export interface IWebSocketAction extends Action {}

export const webSocketConnect = () => ({
  type: WS_CONNECTED,
});

export const webSocketDisconnect = () => ({
  type: WS_DISCONNECTED,
});
